/* eslint-disable prettier/prettier */
/* eslint-disable */

export default {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};
